// routes/FrontendRoutes.js

import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Competitors from "../components/Frontend/Competitors/Competitors";
import { CompetitorProvider } from "../context/CompetitorContext";

export const competitorsRoute = (
  <>
    <Route
      path="/clients_competitors/:clientId?/:clientName?"
      element={<MainLayout />}
    >
      <Route
        index
        element={
          <CompetitorProvider>
            <Competitors />
          </CompetitorProvider>
        }
      />
    </Route>
  </>
);
